export const coolIconKeys: string[] = [
    "table_rows", "video_label",
    "airlines", "bento", "border_all", "border_clear", "ac_unit",
    "adjust", "align_horizontal_center", "album", "all_inclusive",
    "all_out", "animation", "assistant", "audiotrack",
    "account_balance_wallet", "auto_awesome_mosaic", "bolt", "brightness_1", "breakfast_dining",
    "broken_image", "brightness_5", "cable", "calendar_view_month",
    "casino", "category", "cloud", "color_lens",
    "credit_card", "earbuds", "egg_alt", "fiber_smart_record", "flag",
    "healing", "heat_pump", "hive", "hub", "local_library", "local_pizza",
    "memory", "outlet", "pages", "panorama_photosphere", "signal_cellular_0_bar",
    "sports_baseball", "storm", "stairs", "keyboard_command_key"];
